import { styled } from '@mui/material/styles'
import { CardActions } from '@mui/material'

const PREFIX = 'CommonCardFooter'

const classes = {
  footerActions: `${PREFIX}-footerActions`,
}

const StyledCardActions = styled(CardActions)(({ theme }) => ({
  [`&.${classes.footerActions}`]: {
    flex: '1 1 auto',
    cursor: 'pointer',
    display: 'block',
  },
}))

const CommonCardFooter = props => {
  return (
    <StyledCardActions className={classes.footerActions}>
      {props.footeractions}
    </StyledCardActions>
  )
}

export default CommonCardFooter
